import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { onAuthStateChanged } from "firebase/auth";
import { auth, isUserAdmin } from "../firebase";
import { DashboardLayout } from "./dashboard/DashboardLayout";

export function Dashboard() {
  const navigate = useNavigate();
  const [isApproved, setIsApproved] = useState(false);
  const [isCheckingAccess, setIsCheckingAccess] = useState(true);

  useEffect(() => {
    let isMounted = true;

    const checkAdminStatus = async (user) => {
      if (!user) {
        if (isMounted) {
          setIsApproved(false);
          setIsCheckingAccess(false);
        }
        return;
      }

      const adminStatus = await isUserAdmin(user.uid);

      if (isMounted) {
        setIsApproved(adminStatus);
        setIsCheckingAccess(false);

        if (!adminStatus) {
          navigate("/dashboard/noli/nutrition", { replace: true });
        }
      }
    };

    checkAdminStatus(auth.currentUser);

    const unsubscribe = onAuthStateChanged(auth, (user) => {
      if (user) {
        checkAdminStatus(user);
      } else {
        setIsApproved(false);
        navigate("/");
      }
    });

    return () => {
      isMounted = false;
      unsubscribe();
    };
  }, [navigate]);

  if (isCheckingAccess) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-black text-white">
        <p>Loading...</p>
      </div>
    );
  }

  if (!isApproved) {
    return null;
  }

  return <DashboardLayout isAdmin={isApproved} />;
}
